<template>
    <div class="conBody">
        <div class="accountManage">
            <p class="account_manage_title">My contribution</p>
            <div class="addBtn">
                <span @click="goback()">Back</span>
            </div>
            <div class="tab-contents">
                <div class="nano video_breviary" id="accountSettings">
                    <div class="nano-content" id="home_right_list">
                        <div class="taskStatus col-md-12">
                            <div class="statusA" v-if="item.status ==2 && item.content_id">
                                <span class="Ablock ba">Drafted</span>
                                <span class="va">Congratulations, your released content has been drafted and has been officially listed.</span>
                            </div>
                            <!--<div class="statusB" @click='maskShow=!maskShow'>-->
                                <!--查看 &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2.png" alt="" width="8px" height="13px">-->
                            <!--</div>-->
                            <div class="statusA" v-if="item.status ==1">
                                <span class="Ablock bb">Under Review</span>
                                <span class="ve">The content is under review, please wait patiently.</span>
                            </div>
                            <div class="statusA" v-if="item.status ==4">
                                <span class="Ablock bc">Drafts</span>
                                <span class="ve">In the preview; it has not been published yet, and the preview address is only visible to you.</span>
                            </div>
                            <!--<div class="statusB" @click='maskShow=!maskShow'>-->
                                <!--查看 &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2x.png" alt="" width="8px" height="13px">-->
                            <!--</div>-->
                            <div class="statusA" v-if="item.status ==2 && !item.content_id">
                                <span class="Ablock bd">Reviewed</span>
                                <span class="va">Congratulations, your released content has been approved. Please be patient and wait for the editor to draft.</span>
                            </div>
                            <!--<div class="statusB" @click='maskShow=!maskShow'>-->
                                <!--查看 &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2x.png" alt="" width="8px" height="13px">-->
                            <!--</div>-->
                            <div class="statusD" v-if="item.status ==3">
                                <span class="Ablock be">Rejected</span>
                                <span class="ve">Reason for rejection：{{item.refuse_reason}}</span>
                            </div>
                            <div class="statusB va" @click='maskShow=!maskShow' v-if="item.status ==2 && item.content_id">
                                Check &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2.png" alt="" width="8px" height="13px" style="margin-bottom:10px;"/>
                            </div>
                            <div class="statusB va" @click='maskShow=!maskShow' v-if="item.status ==2 && !item.content_id">
                                Check &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2.png" alt="" width="8px" height="13px" style="margin-bottom:10px;" />
                            </div>
                            <div class="statusB ve" @click='maskShow=!maskShow' v-if="item.status ==3">
                                Check &nbsp <img src="../../../assets/images/silkRoadBase/Chevron@2.png" alt="" width="8px" height="13px" style="margin-bottom:10px;"/>
                            </div>
                        </div>

                            <div class="taskDetail">
                                <p class="taskTitle">{{item.title}}</p>
                                <p class="taskTime">
                                    <!--<span>新华社</span>-->
                                    <span v-if="item.published">{{item.published}}</span>
                                    <span v-if="item.name">Editor：{{item.name}}</span>
                                </p>
                                <div class="information_article_abstract rounded">
                                    <p>Abstract：{{item.description}}</p>
                                </div>
                                <div v-html="item.content"></div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <!--发布内容已审核通过-->
        <div class="mask col-md-5" v-show='maskShow && item.status ==2 && !item.content_id'>
            <img src="../../../assets/images/silkRoadBase/sucess.png" alt="">
            <p>Congratulations, your released content has been approved.</p>
            <p>Please be patient and wait for the editor to draft.</p>
            <p>Review time：{{item.audit_time}}</p>
            <span @click="maskShow=!maskShow">OK</span>
        </div>
        <!--发布内容已退稿-->
        <div class="mask col-md-5" v-show='maskShow && item.status ==2 && item.content_id'>
            <img src="../../../assets/images/silkRoadBase/sucess.png" alt="">
            <p>Congratulations, your released content has been drafted </p>
            <p>and has been officially listed.</p>
            <p>Review time：{{item.audit_time}}</p>
            <span @click="maskShow=!maskShow">OK</span>
        </div>
        <!--投稿已退稿-->
        <div class="mask col-md-5" v-show='maskShow && item.status==3'>
            <img src="../../../assets/images/silkRoadBase/fail.png" alt="">
            <p>Unfortunately, your contribution has been rejected.</p>
            <p>Review time：{{item.audit_time}}</p>
            <p>Reason for rejection：{{item.refuse_reason}}</p>
            <span @click="maskShow=!maskShow">OK</span>
        </div>
    </div>

</template>

<script>
    // import './static/css/accountSettings.css'
    export default {
        name: "contributeAdd",
        data() {
            return {
                id : this.$route.params.id,
                item : {},
                maskShow:false
            }
        },
        created: function() {
            this.$axios.post('/api/pc/previewcontribute', {id:this.id}).then((res) => {
                if (res.data.state) {
                    this.item = res.data.data;
                }
            });

        },
        methods: {
            goback() {
                this.$router.push({path: "/accountSettings/contribute"});
            },

        },
        activated() {
            this.$axios.post('/api/pc/previewcontribute', {id:this.$route.params.id}).then((res) => {
                if (res.data.state) {
                this.item = res.data.data;
            }
        });
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
    .accountManage {
        position: relative;
    }
    .mask img{
        width:50px;
        height:50px;
    }
    .reqiued{
        color: red;
        margin-right:10px
    }
    .tab-contents{
        padding-top:0px
    }
    .tab-contents lable{
        padding-left:0;
        padding-right:0;
    }
    .information_article_abstract {
        background: #E8EAEF;
        margin: 20px 0px 20px 0px;
    }
    .information_article_abstract p {
        padding: 12px 20px;
        font-size: 14px;
        color: #4F5362;
        letter-spacing: 0;
        text-align: justify;
        line-height: 30px;
    }
    .myBtn.cur{
        background:rgba(242,243,244,.8);
        color:rgba(133,144,166,1);
        margin-left:30px!important;
    }
    .myBtn.cur:hover{
        background:rgba(242,243,244,1);
        cursor:pointer;
    }
    .myBtn:hover{
        background:rgba(32,142,255,1);
        cursor:pointer;
    }
    .myBtn{
        width:140px;
        height:34px;
        background:rgba(32,142,255,.8);
        border-radius:4px;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        text-align:center;
        color:rgba(255,255,255,1);
        line-height:34px;
        display:inline-block
    }
    .addBtn {
        position: absolute;
        right: 40px;
        top: 20px;
        width: 60px;
        height: 30px;
        background: rgba(242, 243, 244, 1);
        border-radius: 20px;
        text-align: center;
    }

    .addBtn:hover {
        cursor: pointer;
    }

    .addBtn span {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 30px;
        display: block;
    }
    .taskStatus{
        display:flex;
        justify-content:space-between;
        height:38px;
        background:rgba(254,252,235,1);
        padding:8px 30px
    }
    .statusA{
        padding:0;
    }
    .statusA span{
        display: block;
        float:left;

    }
    .statusA span:nth-child(2){
        overflow:hidden;
        height:20px;
        margin-left:10px;
    }
    .statusD{
        padding:0;
    }
    .statusD span{
        display: block;
        float:left;
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:white;
        line-height:20px;
    }
    .statusD span:nth-child(2){
        overflow:hidden;
        height:20px;
        margin-left:10px;
        color:rgba(249,106,14,1);
    }
    .conBody{
        position:relative;
    }

    .Ablock{
        width:53px;
        line-height: 20px;
        height:20px;
        /*background:rgba(69,133,245,1);*/
        border-radius:10px;
        font-size:12px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:white;
        text-align:center;
    }
    .statusD .Ablock{
        /*background:rgba(249,106,14,1);*/
    }
    .statusB{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        /*color:rgba(69,133,245,1);*/
        width:70px;
    }
    .va{
        /*蓝色*/
        color:rgba(69,133,245,1);
    }
    .ba{
        background: rgba(69,133,245,1);
    }
    .bb{
        background: #ffb310;
    }
    .bc{
        background: #c3c3c3;
    }
    .bd{
        background:rgba(69,133,245,1);
    }
    .be{
        background:#fc5d4d;
    }
    .vd{
        /*红色*/
        color:#fc5d4d;
    }
    .vb{
        /*灰色*/
        color:#c3c3c3;
    }
    .ve{
        /*橙色*/
        color:#f96a0e;
    }
    .statusB:hover{
        cursor:pointer;
    }
    .taskDetail{
        padding:0 30px 30px;
    }
    .taskTitle{
        font-size:20px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        margin-top:20px!important;
        line-height:24px;
    }
    .taskTime{
        height:12px;
        font-size:12px;
        margin-top:20px!important;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(128,130,141,1);
        line-height:12px;
    }
    .taskTime span{
        margin-right:20px;
    }
    .taskDes{
        font-size:15px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        padding:15px;
        color:rgba(84,87,102,1);
        line-height:30px;
        position:relative;
        border:1px  dashed #333;
        margin-top:40px;
        margin-bottom:10px;
    }
    .taskDes:before{
        content:"摘要";
        position:absolute;
        top: -15px;
        width:40px;
        background-color: white;
    }
    .mask{
        position: absolute;
        left: 0px;
        min-height:200px;
        max-height:300px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
        border-radius:2px;
        right: 0px;
        bottom: 0px;
        padding:30px 40px;
        top: 0px;
        margin: auto;
        text-align:center;
        z-index:9999;
    }
    .mask p{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        margin-top:20px!important;
    }
    .mask p:nth-child(0){
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:25px;
    }
    .mask span{
        width:126px;
        height:32px;
        background:rgba(32,142,255,1);
        border-radius:16px;
        display:block;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        margin:30px auto 0;
        line-height:32px;
    }
    .mask span:hover{
        cursor: pointer;
    }



</style>
